import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import cx from 'classnames';
import moment from 'moment';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLExcludedDrivers({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const formatDOB = (dateOfBirth) => {
        const date = MLLocalDateUtil.localDate2Date(dateOfBirth);
        return moment(date).format('MM/DD/YYYY');
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr className="table-data">
                    <th />
                    <th>{translator(messages.Name)}</th>
                    <th>{translator(messages.DOB)}</th>
                    <th>{translator(messages.Gender)}</th>
                    <th>{translator(messages.MaritalStatus)}</th>
                    <th>{translator(messages.RelationshipToInsured)}</th>
                    <th>{translator(messages.ReasonNotListed)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.ExcludedDrivers)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped, styles.summaryTable)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((driver) => {
                            return (
                                <>
                                    <tr>
                                        <td />
                                        <td><strong>{driver.displayName}</strong></td>
                                        <td>{formatDOB(driver.dateOfBirth)}</td>
                                        <td>{driver.gender_ML}</td>
                                        <td>{driver.maritalStatus_ML}</td>
                                        <td>{driver.relationshipToInsured_ML}</td>
                                        <td>{driver.status_ML}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLExcludedDrivers.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLExcludedDrivers.defaultProps = {
    data: [],
    show: false
};
export default MLExcludedDrivers;
